import { render, staticRenderFns } from "./setChooseTextByVoiceSimulation.vue?vue&type=template&id=1d648e9f&scoped=true"
import script from "./setChooseTextByVoiceSimulation.vue?vue&type=script&lang=js"
export * from "./setChooseTextByVoiceSimulation.vue?vue&type=script&lang=js"
import style0 from "./setChooseTextByVoiceSimulation.vue?vue&type=style&index=0&id=1d648e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d648e9f",
  null
  
)

export default component.exports